(() => {
  if (window.lldgSmoothScrollLoaded) return;
  window.lldgSmoothScrollLoaded = true;

  const root = document.documentElement;
  const loader = document.currentScript;
  const lenisModuleUrl = loader?.dataset.lenisModule;
  const desktopPointer = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let pageActive = true;
  let lenis = null;
  let lenisModulePromise = null;

  const environmentAllowsMotion = () =>
    pageActive &&
    root.dataset.smoothScroll === 'true' &&
    root.dataset.motionEnabled !== 'false' &&
    !window.Shopify?.designMode &&
    desktopPointer.matches &&
    !reducedMotion.matches;

  const loadLenis = () => {
    if (typeof window.Lenis === 'function') return Promise.resolve();
    if (!lenisModuleUrl) return Promise.reject(new Error('Smooth-scroll module URL is missing.'));
    if (lenisModulePromise) return lenisModulePromise;

    lenisModulePromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = lenisModuleUrl;
      script.defer = true;
      script.dataset.lldgLenis = 'true';
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', () => reject(new Error('Smooth-scroll module could not be loaded.')), {
        once: true,
      });
      document.head.append(script);
    });

    return lenisModulePromise;
  };

  const stop = () => {
    if (lenis) {
      lenis.destroy();
      lenis = null;
    }
    root.removeAttribute('data-smooth-scroll-ready');
  };

  const start = async () => {
    if (!environmentAllowsMotion()) {
      stop();
      return;
    }
    if (lenis) return;

    try {
      await loadLenis();
    } catch (error) {
      console.warn(error.message);
      return;
    }
    if (lenis || !environmentAllowsMotion() || typeof window.Lenis !== 'function') return;

    lenis = new window.Lenis({
      autoRaf: true,
      anchors: true,
      allowNestedScroll: true,
      smoothWheel: true,
      syncTouch: false,
      lerp: 0.11,
      wheelMultiplier: 0.95,
      overscroll: true,
      stopInertiaOnNavigate: true,
      respectReducedMotion: true,
    });
    root.dataset.smoothScrollReady = 'true';
  };

  const refresh = () => {
    if (!environmentAllowsMotion()) {
      stop();
      return;
    }
    if (!lenis) {
      start();
      return;
    }
    lenis.resize();
  };

  const addMediaListener = (mediaQuery) => {
    if (typeof mediaQuery.addEventListener === 'function') mediaQuery.addEventListener('change', refresh);
    else mediaQuery.addListener(refresh);
  };

  addMediaListener(desktopPointer);
  addMediaListener(reducedMotion);
  document.addEventListener('shopify:section:load', refresh);
  const suspend = () => {
    pageActive = false;
    stop();
  };
  window.addEventListener('pageshow', () => {
    pageActive = true;
    refresh();
  });
  window.addEventListener('pagehide', suspend);
  window.addEventListener('beforeunload', suspend, { once: true });
  start();
})();
